export enum LayoutData_ImagePosition {
  /** CENTER - Image positioned at the center */
  CENTER = 'CENTER',
  /** CENTER_LEFT - Image positioned on the left */
  CENTER_LEFT = 'CENTER_LEFT',
  /** CENTER_RIGHT - Image positioned on the right */
  CENTER_RIGHT = 'CENTER_RIGHT',
  /** TOP - Image positioned at the center top */
  TOP = 'TOP',
  /** TOP_LEFT - Image positioned at the top left */
  TOP_LEFT = 'TOP_LEFT',
  /** TOP_RIGHT - Image positioned at the top right */
  TOP_RIGHT = 'TOP_RIGHT',
  /** BOTTOM - Image positioned at the center bottom */
  BOTTOM = 'BOTTOM',
  /** BOTTOM_LEFT - Image positioned at the bottom left */
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  /** BOTTOM_RIGHT - Image positioned at the bottom right */
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum LayoutData_ResponsivenessBehaviour {
  /** STACK - Stacking of columns */
  STACK = 'STACK',
  /** WRAP - Wrapping of columns */
  WRAP = 'WRAP',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum LayoutData_VerticalAlignment_Alignment {
  /** TOP - Top alignment */
  TOP = 'TOP',
  /** MIDDLE - Middle alignment */
  MIDDLE = 'MIDDLE',
  /** BOTTOM - Bottom alignment */
  BOTTOM = 'BOTTOM',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum LayoutData_ImageScaling_Scaling {
  /** AUTO - Auto image scaling */
  AUTO = 'AUTO',
  /** CONTAIN - Contain image scaling */
  CONTAIN = 'CONTAIN',
  /** COVER - Cover image scaling */
  COVER = 'COVER',
  UNRECOGNIZED = 'UNRECOGNIZED',
}